<template>
    <div class="title">
        <a-row type="flex">
            <a-col flex="200px">
                <div class="avatar-container">
                    <a-avatar shape="square" :size="96" :src="avatar" />
                </div>
            </a-col>
            <a-col flex="auto">
                <a-row>
                    <a-page-header
                        :title="name" :sub-title="id"
                        :backIcon="false"
                    >
                        <template slot="extra" v-if="canFollow">
                            <a-button v-if="hasFollow" type="dashed" title="取消关注" @click="follow(false)">
                                已关注
                            </a-button>
                            <a-button v-else type="primary" icon="plus" @click="follow(true)">
                                关注
                            </a-button>
                        </template>
                    </a-page-header>
                </a-row>
            </a-col>
        </a-row>
    </div>
</template>

<script>
export default {
    props: [ 'name', 'avatar', 'id', 'hasFollow', 'canFollow' ],
    methods: {
        follow(opt) {
            this.$emit("follow", opt);
        }
    }
}
</script>

<style lang="less" scoped>
.title {
    background-color: #f6f6f6;
    padding: 10px;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 3px rgba(18,18,18,.1);
    box-shadow: 0 1px 3px rgba(18,18,18,.1);
    margin: 6px;
}
.avatar-container {
    text-align: center;
}
</style>